/* ============================================================
   ENDLESS EMOTOS — Theme JavaScript
   ============================================================ */

(function(){
  'use strict';

  /* ---------- Countdown timer (announcement bar) ---------- */
  function initCountdown(){
    var h = document.getElementById('cd-h');
    var m = document.getElementById('cd-m');
    var s = document.getElementById('cd-s');
    if(!h || !m || !s) return;

    var total = parseInt(h.textContent,10)*3600 + parseInt(m.textContent,10)*60 + parseInt(s.textContent,10);
    setInterval(function(){
      if(total <= 0){ total = 24*3600; }
      total--;
      var hh = Math.floor(total/3600);
      var mm = Math.floor((total%3600)/60);
      var ss = total%60;
      h.textContent = String(hh).padStart(2,'0');
      m.textContent = String(mm).padStart(2,'0');
      s.textContent = String(ss).padStart(2,'0');
    }, 1000);
  }

  /* ---------- Thumbnail gallery ---------- */
  function initGallery(){
    var thumbs = document.getElementById('galleryThumbs');
    var mainImg = document.getElementById('mainProductImage');
    if(!thumbs) return;

    thumbs.addEventListener('click', function(e){
      var thumb = e.target.closest('.thumb');
      if(!thumb) return;
      thumbs.querySelectorAll('.thumb').forEach(function(t){ t.classList.remove('active'); });
      thumb.classList.add('active');

      if(mainImg && thumb.dataset.src){
        mainImg.src = thumb.dataset.src;
      }
    });
  }

  /* ---------- Quantity stepper ---------- */
  function initQtyStepper(){
    var minus = document.getElementById('qtyMinus');
    var plus = document.getElementById('qtyPlus');
    var input = document.getElementById('qtyInput');
    if(!minus || !plus || !input) return;

    minus.addEventListener('click', function(){
      var v = parseInt(input.value,10) || 1;
      input.value = Math.max(1, v - 1);
    });
    plus.addEventListener('click', function(){
      var v = parseInt(input.value,10) || 1;
      input.value = Math.min(99, v + 1);
    });
  }

  /* ---------- Variant selectors ---------- */
  function initVariantSelectors(){
    document.querySelectorAll('.swatch-row').forEach(function(row){
      row.addEventListener('click', function(e){
        var btn = e.target.closest('.swatch');
        if(!btn) return;

        row.querySelectorAll('.swatch').forEach(function(b){ b.classList.remove('selected'); });
        btn.classList.add('selected');

        var selectedLabel = row.closest('.variant-group').querySelector('.selected');
        if(selectedLabel){
          selectedLabel.textContent = btn.textContent.trim() || btn.getAttribute('title') || '';
        }

        updateVariantFromSelectors();
      });
    });
  }

  /* ---------- Update Shopify variant from selectors ---------- */
  function updateVariantFromSelectors(){
    if(typeof window.productVariants === 'undefined') return;

    var options = [];
    document.querySelectorAll('.variant-group').forEach(function(group){
      var selected = group.querySelector('.swatch.selected');
      if(selected) options.push(selected.textContent.trim() || selected.getAttribute('title') || '');
    });

    var match = null;
    for(var i=0; i<window.productVariants.length; i++){
      var v = window.productVariants[i];
      var isMatch = true;
      for(var j=0; j<options.length; j++){
        if(v.options[j] !== options[j]){ isMatch=false; break; }
      }
      if(isMatch){ match = v; break; }
    }

    if(match){
      var variantInput = document.getElementById('variantId');
      if(variantInput) variantInput.value = match.id;

      var priceNow = document.getElementById('priceNow');
      var ctaPrice = document.getElementById('ctaPrice');
      var stickyPrice = document.getElementById('stickyPrice');
      var formattedPrice = Shopify.formatMoney ? Shopify.formatMoney(match.price) : ('$' + (match.price/100).toFixed(2));

      if(priceNow) priceNow.textContent = formattedPrice;
      if(ctaPrice) ctaPrice.textContent = formattedPrice;
      if(stickyPrice) stickyPrice.textContent = formattedPrice;

      var priceWas = document.getElementById('priceWas');
      var priceSave = document.getElementById('priceSaveBadge');
      if(match.compare_at_price && match.compare_at_price > match.price){
        var formattedCompare = Shopify.formatMoney ? Shopify.formatMoney(match.compare_at_price) : ('$' + (match.compare_at_price/100).toFixed(2));
        if(priceWas){ priceWas.style.display=''; priceWas.textContent = formattedCompare; }
        if(priceSave){
          priceSave.style.display='';
          priceSave.textContent = 'Save ' + Math.round((1 - match.price/match.compare_at_price)*100) + '%';
        }
      } else {
        if(priceWas) priceWas.style.display='none';
        if(priceSave) priceSave.style.display='none';
      }

      var addBtn = document.getElementById('addToCartBtn');
      if(addBtn){
        addBtn.disabled = !match.available;
        if(!match.available){
          addBtn.innerHTML = 'Sold Out';
        } else {
          addBtn.innerHTML = 'Add to Cart &mdash; <span id="ctaPrice">' + formattedPrice + '</span>';
        }
      }
    }
  }

  /* ---------- Format money helper ---------- */
  function formatMoney(cents){
    if(typeof Shopify !== 'undefined' && Shopify.formatMoney) return Shopify.formatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------- Cart Drawer ---------- */
  function openCartDrawer(){
    var drawer = document.getElementById('cartDrawer');
    var overlay = document.getElementById('cartDrawerOverlay');
    if(drawer) drawer.classList.add('open');
    if(overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer(){
    var drawer = document.getElementById('cartDrawer');
    var overlay = document.getElementById('cartDrawerOverlay');
    if(drawer) drawer.classList.remove('open');
    if(overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  /* Shipping protection state */
  var _spVariants = null;
  var _spSwapping = false;

  function renderCartDrawer(cart){
    var body = document.getElementById('cartDrawerBody');
    var footer = document.getElementById('cartDrawerFooter');
    var empty = document.getElementById('cartDrawerEmpty');
    var totalEl = document.getElementById('cartDrawerTotal');
    if(!body) return;

    /* Shipping protection config */
    var spEl = document.getElementById('shippingProtection');
    var spProductId = spEl ? parseInt(spEl.dataset.productId, 10) : null;

    /* Update header cart count */
    document.querySelectorAll('.cart-count').forEach(function(el){
      el.textContent = cart.item_count;
    });

    if(cart.item_count === 0){
      body.innerHTML = '';
      if(footer) footer.style.display = 'none';
      if(empty) empty.style.display = 'block';
      var spToggle = document.getElementById('spToggle');
      if(spToggle) spToggle.checked = false;
      return;
    }

    if(footer) footer.style.display = '';
    if(empty) empty.style.display = 'none';
    var finalTotal = Math.round(parseFloat(cart.total_price) || 0);
    if(totalEl) totalEl.textContent = formatMoney(finalTotal);

    /* Calculate subtotal without protection & find protection line */
    var baseSubtotal = 0;
    var spLineIndex = -1;
    var spCurrentVid = null;
    cart.items.forEach(function(item, idx){
      if(spProductId && item.product_id === spProductId){
        spLineIndex = idx;
        spCurrentVid = item.variant_id;
      } else {
        var price = Math.round(parseFloat(item.line_price) || 0);
        baseSubtotal += price;
      }
    });

    /* Sync toggle */
    var spToggle = document.getElementById('spToggle');
    if(spToggle) spToggle.checked = (spLineIndex > -1);

    /* Update price display and auto-swap variant if needed */
    if(spEl && _spVariants && _spVariants.length > 0){
      var pct = parseFloat(spEl.dataset.percentage) || 3;
      var targetCents = Math.round((baseSubtotal || 0) * (pct || 0) / 100) || 0;
      if(targetCents < 1) targetCents = _spVariants[0].price;

      /* Find closest available variant */
      var best = _spVariants[0];
      var bestDiff = Math.abs(best.price - targetCents);
      for(var v = 1; v < _spVariants.length; v++){
        var d = Math.abs(_spVariants[v].price - targetCents);
        if(d < bestDiff){ best = _spVariants[v]; bestDiff = d; }
      }

      /* Update displayed price */
      var priceDisp = document.getElementById('spPriceDisplay');
      if(priceDisp) priceDisp.textContent = formatMoney(best.price);
      spEl.dataset.activeVariantId = best.id;

      /* If protection is in cart but wrong tier, swap it */
      if(spLineIndex > -1 && spCurrentVid !== best.id && !_spSwapping){
        _spSwapping = true;
        fetch('/cart/change.js', {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ line: spLineIndex + 1, quantity: 0 })
        })
        .then(function(r){ return r.json(); })
        .then(function(){
          return fetch('/cart/add.js', {
            method:'POST', headers:{'Content-Type':'application/json'},
            body: JSON.stringify({ id: best.id, quantity: 1 })
          });
        })
        .then(function(r){ return r.json(); })
        .then(function(){ return fetch('/cart.js'); })
        .then(function(r){ return r.json(); })
        .then(function(updatedCart){ _spSwapping = false; renderCartDrawer(updatedCart); })
        .catch(function(){ _spSwapping = false; });
      }
    }

    /* Build line items HTML */
    var html = '';
    cart.items.forEach(function(item, index){
      /* Hide shipping protection from line items */
      if(spProductId && item.product_id === spProductId) return;

      var line = index + 1;
      var imgSrc = item.image ? item.image.replace(/(\.\w+)(\?|$)/, '_120x$1$2') : '';
      var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';

      html += '<div class="cart-drawer-item" data-line="' + line + '" data-key="' + item.key + '">';
      if(imgSrc){
        html += '<img src="' + imgSrc + '" alt="' + item.title.replace(/"/g,'&quot;') + '">';
      }
      html += '<div class="cart-drawer-item-info">';
      html += '<div class="cart-drawer-item-title">' + item.product_title + '</div>';
      if(variantTitle){
        html += '<div class="cart-drawer-item-variant">' + variantTitle + '</div>';
      }
      html += '<div class="cart-drawer-item-bottom">';
      html += '<div class="cart-drawer-item-qty">';
      html += '<button type="button" class="drawer-qty-minus" data-line="' + line + '">−</button>';
      html += '<input type="number" class="drawer-qty-input" value="' + item.quantity + '" min="0" max="99" data-line="' + line + '">';
      html += '<button type="button" class="drawer-qty-plus" data-line="' + line + '">+</button>';
      html += '</div>';
      html += '<div class="cart-drawer-item-price">' + formatMoney(item.line_price) + '</div>';
      html += '</div>';
      html += '</div></div>';
    });

    body.innerHTML = html;
  }

  function drawerUpdateCart(line, quantity){
    fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function(r){ return r.json(); })
    .then(function(cart){
      /* Shopify returns an error object (no items) when the requested quantity
         exceeds available stock. Reload the real cart instead of rendering it. */
      if(!cart || !Array.isArray(cart.items)){
        var msg = (cart && (cart.description || cart.message)) || 'That quantity is not available.';
        return fetch('/cart.js')
          .then(function(r){ return r.json(); })
          .then(function(realCart){
            renderCartDrawer(realCart);
            showDrawerNotice(msg);
          });
      }
      renderCartDrawer(cart);
    })
    .catch(function(){
      fetch('/cart.js').then(function(r){ return r.json(); }).then(renderCartDrawer);
    });
  }

  function showDrawerNotice(msg){
    var body = document.getElementById('cartDrawerBody');
    if(!body) return;
    var old = body.querySelector('.cart-drawer-notice');
    if(old) old.remove();
    var n = document.createElement('div');
    n.className = 'cart-drawer-notice';
    n.style.cssText = 'background:rgba(255,80,80,.12);border:1px solid rgba(255,80,80,.4);color:#ff8a8a;font-size:13px;padding:10px 12px;border-radius:8px;margin-bottom:12px;';
    n.textContent = msg;
    body.insertBefore(n, body.firstChild);
    setTimeout(function(){ if(n.parentNode) n.remove(); }, 5000);
  }

  function initCartDrawer(){
    var closeBtn = document.getElementById('cartDrawerClose');
    var overlay = document.getElementById('cartDrawerOverlay');
    var body = document.getElementById('cartDrawerBody');
    var shopBtn = document.getElementById('cartDrawerShop');

    if(closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
    if(overlay) overlay.addEventListener('click', closeCartDrawer);
    if(shopBtn) shopBtn.addEventListener('click', function(e){
      e.preventDefault();
      closeCartDrawer();
    });

    /* Handle typed quantity changes */
    if(body){
      body.addEventListener('change', function(e){
        var input = e.target.closest('.drawer-qty-input');
        if(!input) return;
        var line = parseInt(input.dataset.line, 10);
        var val = parseInt(input.value, 10);
        if(isNaN(val) || val < 0) val = 1;
        if(val > 99) val = 99;
        drawerUpdateCart(line, val);
      });
    }

    /* Delegate clicks inside the drawer body */
    if(body){
      body.addEventListener('click', function(e){
        var minus = e.target.closest('.drawer-qty-minus');
        var plus = e.target.closest('.drawer-qty-plus');

        if(minus){
          var line = parseInt(minus.dataset.line, 10);
          var qtyEl = minus.nextElementSibling;
          var current = parseInt(qtyEl.value, 10);
          var newQty = current <= 1 ? 0 : current - 1;
          qtyEl.value = newQty;
          minus.disabled = true;
          drawerUpdateCart(line, newQty);
        }
        if(plus){
          var line2 = parseInt(plus.dataset.line, 10);
          var qtyEl2 = plus.previousElementSibling;
          var current2 = parseInt(qtyEl2.value, 10);
          if(current2 >= 99) return;
          var newQty2 = current2 + 1;
          qtyEl2.value = newQty2;
          plus.disabled = true;
          drawerUpdateCart(line2, newQty2);
        }
      });
    }

    /* Shipping protection — pre-fetch variants & toggle */
    var spEl = document.getElementById('shippingProtection');
    var spToggle = document.getElementById('spToggle');
    if(spEl && spEl.dataset.productHandle){
      fetch('/products/' + spEl.dataset.productHandle + '.js')
        .then(function(r){ return r.json(); })
        .then(function(p){
          _spVariants = p.variants.filter(function(v){ return v.available; });
        })
        .catch(function(){});
    }
    if(spToggle && spEl){
      spToggle.addEventListener('change', function(){
        var vid = parseInt(spEl.dataset.activeVariantId || spEl.dataset.variantId, 10);
        if(spToggle.checked){
          fetch('/cart/add.js', {
            method:'POST', headers:{'Content-Type':'application/json'},
            body: JSON.stringify({ id: vid, quantity: 1 })
          })
          .then(function(r){ return r.json(); })
          .then(function(){ return fetch('/cart.js'); })
          .then(function(r){ return r.json(); })
          .then(function(cart){ renderCartDrawer(cart); });
        } else {
          var spPid = parseInt(spEl.dataset.productId, 10);
          fetch('/cart.js')
          .then(function(r){ return r.json(); })
          .then(function(cart){
            for(var i=0; i<cart.items.length; i++){
              if(cart.items[i].product_id === spPid){
                drawerUpdateCart(i + 1, 0);
                return;
              }
            }
          });
        }
      });
    }

    /* Make the header cart icon open the drawer instead of going to /cart */
    var cartLinks = document.querySelectorAll('.header-actions a[href="/cart"]');
    cartLinks.forEach(function(link){
      link.addEventListener('click', function(e){
        e.preventDefault();
        fetch('/cart.js')
          .then(function(r){ return r.json(); })
          .then(function(cart){
            renderCartDrawer(cart);
            openCartDrawer();
          });
      });
    });
  }

  /* ---------- Add to cart (AJAX) ---------- */
  function initAddToCart(){
    var form = document.getElementById('productForm');
    if(!form) return;

    form.addEventListener('submit', function(e){
      e.preventDefault();
      var addBtn = document.getElementById('addToCartBtn');
      var variantId = document.getElementById('variantId');
      var qty = document.getElementById('productQty');

      if(!variantId) return;

      var data = {
        id: parseInt(variantId.value,10),
        quantity: parseInt(qty ? qty.value : 1,10)
      };

      if(addBtn){
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';
      }

      fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify(data)
      })
      .then(function(r){ return r.json(); })
      .then(function(){
        if(addBtn){
          addBtn.textContent = 'Added ✓';
          setTimeout(function(){
            addBtn.disabled = false;
            var p = document.getElementById('ctaPrice');
            addBtn.innerHTML = 'Add to Cart &mdash; <span id="ctaPrice">' + (p ? p.textContent : '') + '</span>';
          }, 1400);
        }
        /* Fetch full cart and open the drawer */
        fetch('/cart.js')
          .then(function(r){ return r.json(); })
          .then(function(cart){
            renderCartDrawer(cart);
            openCartDrawer();
            /* Update cart count in header */
            document.querySelectorAll('.cart-count').forEach(function(el){
              el.textContent = cart.item_count;
            });
          });
      })
      .catch(function(){
        if(addBtn){
          addBtn.disabled = false;
          addBtn.textContent = 'Error — try again';
        }
      });
    });

    /* Buy Now */
    var buyBtn = document.getElementById('buyNowBtn');
    if(buyBtn){
      buyBtn.addEventListener('click', function(){
        var variantId = document.getElementById('variantId');
        var qty = document.getElementById('qtyInput');
        if(!variantId) return;
        window.location.href = '/cart/' + variantId.value + ':' + (qty ? qty.value : 1);
      });
    }

    /* Sticky add to cart */
    var stickyBtn = document.getElementById('stickyAddBtn');
    if(stickyBtn){
      stickyBtn.addEventListener('click', function(){
        form.dispatchEvent(new Event('submit'));
      });
    }
  }

  /* ---------- Update cart count badge ---------- */
  function updateCartCount(){
    fetch('/cart.js')
    .then(function(r){ return r.json(); })
    .then(function(cart){
      document.querySelectorAll('.cart-count').forEach(function(el){
        el.textContent = cart.item_count;
      });
    })
    .catch(function(){});
  }

  /* ---------- Sticky add-to-cart bar ---------- */
  function initStickyBar(){
    var ctaRow = document.querySelector('.cta-row');
    var stickyBar = document.getElementById('stickyAtc');
    if(!ctaRow || !stickyBar) return;

    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          stickyBar.classList.remove('show');
        } else if(entry.boundingClientRect.top < 0){
          stickyBar.classList.add('show');
        }
      });
    }, {threshold:0});
    observer.observe(ctaRow);
  }

  /* ---------- Newsletter form ---------- */
  function initNewsletter(){
    var form = document.querySelector('.newsletter-form');
    if(!form) return;
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if(btn){
        btn.textContent = 'Subscribed!';
        btn.disabled = true;
        setTimeout(function(){ btn.textContent = 'Subscribe'; btn.disabled = false; }, 2000);
      }
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu(){
    var burger = document.querySelector('.burger');
    var menu = document.getElementById('mobileMenu');
    var overlay = document.getElementById('mobileOverlay');
    var closeBtn = document.getElementById('mobileMenuClose');
    if(!burger || !menu) return;

    function openMenu(){
      menu.classList.add('open');
      if(overlay) overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeMenu(){
      menu.classList.remove('open');
      if(overlay) overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    burger.addEventListener('click', openMenu);
    if(closeBtn) closeBtn.addEventListener('click', closeMenu);
    if(overlay) overlay.addEventListener('click', closeMenu);
  }

  /* ---------- Collection filters (sidebar toggle + price cents) ---------- */
  function initCollectionFilters(){
    var sidebar = document.getElementById('collectionSidebar');
    var toggleBtn = document.getElementById('filterToggleBtn');
    if(!toggleBtn) return;

    /* Mobile overlay */
    var overlay = document.createElement('div');
    overlay.className = 'cart-drawer-overlay';
    overlay.id = 'filterOverlay';
    document.body.appendChild(overlay);

    function openSidebar(){
      if(sidebar) sidebar.classList.add('open');
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeSidebar(){
      if(sidebar) sidebar.classList.remove('open');
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    toggleBtn.addEventListener('click', openSidebar);
    overlay.addEventListener('click', closeSidebar);

    /* Prevent sidebar clicks from closing it */
    if(sidebar){
      sidebar.addEventListener('click', function(e){
        e.stopPropagation();
      });
    }

    /* Price filter — convert dollars to cents before submit */
    var form = document.getElementById('filterForm');
    if(form){
      form.addEventListener('submit', function(){
        form.querySelectorAll('.filter-price-input').forEach(function(inp){
          if(inp.value !== ''){
            inp.value = Math.round(parseFloat(inp.value) * 100);
          }
        });
      });
    }

    /* Sort dropdown handler */
    window.handleSortChange = function(sel){
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    };
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function(){
    initCountdown();
    initGallery();
    initQtyStepper();
    initVariantSelectors();
    initAddToCart();
    initStickyBar();
    initNewsletter();
    initMobileMenu();
    initCartDrawer();
    initCollectionFilters();
  });

})();